import { cookiebotGroupId } from '../settings';


/**
 * Initializes Cookiebot by adding a script element to the document head, which loads the Cookiebot consent banner script from the specified URL.
 * This function must be called to properly initialize Cookiebot functionality on the page.
 */
const cookiebotInit = () => {

	const script = document.createElement( 'script' );
	script.type = 'text/javascript';
	script.id = 'Cookiebot';
	script.src = `https://consent.cookiebot.com/uc.js?cbid=${cookiebotGroupId}`;
	const firstScript = document.getElementsByTagName( 'script' )[ 0 ];
	firstScript.parentNode.insertBefore( script, firstScript );

}

/**
 * Initializes the Cookiebot script when specified events occur on the HTML element.
 */
const cookiebotLoad = () => {

	let jsInit = false;
	const html = document.querySelector( 'html' );

	/**
	 * Initializes Cookiebot event handler.
	 * If the global variable jsInit is falsy, sets it to true and calls cookiebotInit().
	 */
	const initCookiebotOnEvent = () => {

		if ( !jsInit ) {

			jsInit = true;
			cookiebotInit();

		}

	}

	html.addEventListener( 'mousemove', initCookiebotOnEvent );
	html.addEventListener( 'touchstart', initCookiebotOnEvent );
	html.addEventListener( 'keydown', initCookiebotOnEvent );
	html.addEventListener( 'click', initCookiebotOnEvent );

}

export { cookiebotLoad }

